import type { FunctionComponent, ReactNode, SVGProps } from 'react';
import { z } from 'zod';
import type { Applications } from '../../../../@api-client';
import type { OtaConfig } from '../../../utils/ota-updater/ota-updater';

export type LoginLogo = FunctionComponent<SVGProps<SVGSVGElement>>;

export const loginSchema = z.object({
  email: z.email('Invalid email address'),
  password: z.string().min(6, 'Password must be at least 6 characters'),
});

export type LoginFormData = z.infer<typeof loginSchema>;

export type OtaLoginConfig = {
  config: OtaConfig;
  appName: string;
  appStoreUrl: string;
  loadingFallback: ReactNode;
};

export type LoginPageProps = {
  logo?: LoginLogo;
  hideLogin?: boolean;
  hideSignup?: boolean;
  hideFooter?: boolean;
  enableGoogleLogin?: boolean;
  instructions?: string;
  instructionBlock?: ReactNode;
  requiredApplication?: Applications;
  requiredApplicationName?: string;
  ota?: OtaLoginConfig;
};
